import './App.css'
import { Header } from '../Header/Header'
import { MainPage } from '../../pages/MainPage/MainPage'
import { HashRouter, Routes, Route } from 'react-router-dom'
import { Unsubscribe } from '../../pages/Unsubscribe/Unsubscribe'
import { EventRedirect } from '../../pages/EventRedirect/EventRedirect'

export const App = () => {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header />
                <MainPage />
              </>
            }
          />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/events/:id" element={<EventRedirect />} />
        </Routes>
      </HashRouter>
    </div>
  )
}
